export default {
  "name": "NCSearch",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCSearch",
  "label": "查询区",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "区域编码",
        "type": "string"
      },
      "showSearchBtn": {
        "title": "是否显示查询按钮",
        "description": "是否显示查询按钮",
        "type": "boolean",
        "default": true
      },
      "smshowAdvBtn": {
        "title": "是否显示高级查询按钮",
        "description": "是否显示高级查询按钮",
        "type": "boolean"
      },
      "showClearBtn": {
        "title": "是否显示清空按钮",
        "description": "是否显示清空按钮",
        "type": "boolean",
        "default": true
      },
      "showAdvSearchPlanBtn": {
        "title": "是否显示查询方案按钮",
        "description": "是否显示查询方案按钮",
        "type": "boolean",
        "default": true
      },
      "hideSearchCondition": {
        "title": "隐藏候选条件",
        "description": "隐藏候选条件",
        "type": "boolean",
        "default": false
      },
      "hideBtnArea": {
        "title": "隐藏查询按钮区域",
        "description": "隐藏查询按钮区域",
        "type": "boolean",
        "default": false
      },
      "onlyShowSuperBtn": {
        "title": "只显示高级按钮",
        "description": "只显示高级按钮",
        "type": "boolean",
        "default": false
      },
      "onlyShowAdvArea": {
        "title": "在查询区只显示高级查询面板",
        "description": "在查询区只显示高级查询面板",
        "type": "boolean",
        "default": false
      },
      "onlyShowModal": {
        "title": "在查询区只显示高级查询模态框",
        "description": "在查询区只显示高级查询模态框",
        "type": "boolean",
        "default": false
      },
      "useCache": {
        "title": "是否启用查询区缓存",
        "description": "是否启用查询区缓存",
        "type": "boolean",
        "default": true
      },
      "isSynInitAdvSearch": {
        "title": "是否同步渲染高级查询区",
        "description": "是否同步渲染高级查询区",
        "type": "boolean",
        "default": false
      },
      "onlyShowPlan": {
        "title": "只显示方案列表和高级查询",
        "description": "只显示方案列表和高级查询",
        "type": "boolean",
        "default": false
      },
      "searchModalTitle": {
        "title": "高级查询模态框标题",
        "description": "高级查询模态框标题",
        "type": "boolean"
      },
      "currentSearch": {
        "title": "多个查询组件同时存在时，用来标识当前查询组件",
        "description": "多个查询组件同时存在时，用来标识当前查询组件",
        "type": "boolean",
        "default": true
      },
      "isTemplateOrder": {
        "title": "默认不是模板顺序，如果是模板顺序，则取消必填项优先的逻辑",
        "description": "默认不是模板顺序，如果是模板顺序，则取消必填项优先的逻辑",
        "type": "boolean",
        "default": false
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}